import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { routerStore } from 'core/routing';
import { useChatControl } from 'libs/rendering/hooks';
import { frameStore } from 'apps/components/Frame/appManager';

import { themes } from 'styles/themes/wikifactoryNew';
import { PanelType, routesWithoutChatButtons } from 'constants/global';
import { ChatButtonStyled } from './headerFileFeatures.styled';

export const DiscussButton = observer(() => {
  const { file, contextManager, sharedFileManager, project } = frameStore;
  const chatControl = useChatControl();
  const { isRestricted } = sharedFileManager?.sharedFileQuery?.result || {};
  const shouldShowButton = !project?.isRestricted && !isRestricted;
  const { panel } = routerStore.route.params;
  if (!file) return null;
  if (routesWithoutChatButtons.includes(routerStore.route.name)) return null;

  const isActive = chatControl.chatVisible;

  const handleClick = () => {
    const newParams = Object.assign({}, routerStore.route.params);
    if (newParams.panel === PanelType.Discuss) {
      delete newParams.panel;
    } else {
      newParams.panel = PanelType.Discuss;
    }
    routerStore.navigate(routerStore.route.name, newParams, { replace: true });
  };

  const isFirstLoadPage = !contextManager?.messages?.length;

  useEffect(() => {
    const shouldQueryConversations =
      isFirstLoadPage || panel === PanelType.Discuss;

    if (shouldQueryConversations) {
      contextManager?.QueryConversation();
    }
  }, [isFirstLoadPage, panel]);

  let unreadMessages = 0;
  if (contextManager) unreadMessages = contextManager.unreadCount;
  if (chatControl.chatVisible) unreadMessages = 0;

  return (
    shouldShowButton && (
      <div className='hover:opacity-70'>
        <ChatButtonStyled
          icon='chat_multiple'
          iconPosition='right'
          data-testid='discuss-button'
          text='Discuss'
          onClick={() => {
            handleClick();
          }}
          style={{
            background:
              panel === 'discuss'
                ? themes.color.wfGrey200
                : themes.color.wfWhite,
            borderBottom: `1px solid ${
              isActive ? 'transparent' : themes.color.wfGrey100
            }`,
          }}
          appearance='plain'
          removeBold
          active={isActive}
          badgeValue={unreadMessages}
        />
      </div>
    )
  );
});
